import { render, staticRenderFns } from "./portfolioConfig.vue?vue&type=template&id=32b4706a&scoped=true&"
import script from "./portfolioConfig.vue?vue&type=script&lang=js&"
export * from "./portfolioConfig.vue?vue&type=script&lang=js&"
import style0 from "./portfolioConfig.vue?vue&type=style&index=0&id=32b4706a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b4706a",
  null
  
)

export default component.exports